/**
 * <s-footer-disclosure> — footer column that collapses into a disclosure on phones.
 *
 * Required markup: a single <details> with a <summary> heading.
 * Below 768px the native <details> toggles normally; from 768px up it is forced open
 * and summary clicks are ignored so the columns read as a static footer.
 */
class SFooterDisclosure extends HTMLElement {
  #ac;

  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;

    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const wide = window.matchMedia('(min-width: 768px)');
    const sync = () => {
      this.details.open = wide.matches;
    };

    sync();
    wide.addEventListener('change', sync, opts);
    this.details.querySelector('summary')?.addEventListener('click', (event) => {
      if (wide.matches) event.preventDefault();
    }, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-footer-disclosure')) {
  customElements.define('s-footer-disclosure', SFooterDisclosure);
}
